export const configs = {
    "testFunc": [],
    "recordPerPage": 1000,
    "defaultRowPerPage": 100,
    "startPage": 1,
    "allRecordsFetchedTillNow": "all",
    "assetList": ["BOND", "MLD", "UNLISTED_COMPANY", "GOVERNMENT_SECURITIES", "STARTUP", "PRE_IPO_BUCKET", "MIX_BUCKET"],
    "subCategories": ["now_listed", "realised_gains", "dividend"],
    "accountType": ["NORMAL", "PRO", "PRO_TAGGED"],
    "apiBaseUrl": "https://dev.altiusinvestech.com",
    "phoneRegex": /^[6-9]\d{9}$/,
    "emailRegex": /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    "passRegex": /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
    "passValidationMessage": "Minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character.",
    "remarkCategories": {
        "kyc:kyc_remark": "kyc:kyc_remark",
        "buy_module:payment_pending": "buy_module:payment_pending",
        "buy_module:share_delivered": "buy_module:share_delivered",
        "buy_module:intervention_needed": "buy_module:intervention_needed",
        "sell_module:approve_or_reject_generated_order": "sell_module:approve_or_reject_generated_order",
        "sell_module:share_transfer_pending": "sell_module:share_transfer_pending",
        "sell_module:payment_completed": "sell_module:payment_completed"
    },
    joditConfig: {
        readonly: false,
        controls: {
            font: {
                list: {
                    'Roboto Medium,Arial,sans-serif': 'Roboto',
                    'Comic Neue cursive': 'Comic Sans'
                }
            }
        }
    },
    holdingGraphText: {
        sectorAllocation: {
            text: "Sector Allocation",
            subText: "Based on Curr. Value of Holdings",
            id: "sectorAllocationGraph",
            filterColumns: "sector"
        },
        particulars: {
            text: "Stock Allocation",
            subText: "Based on Curr. Value of Holdings",
            id: "stockAllocationGraph",
            filterColumns: "company_name"
        }
    },
    "shareStatusTypes":
    {
        "All Orders": { name: "All Orders", api: "", functionName: "buy_module:load_all_buy_orders" },
        "Completed Orders": { name: "Completed Orders", api: "completed", functionName: "buy_module:load_completed_orders" },
        "Rejected Orders": { name: "Rejected Orders", api: "rejected", functionName: "buy_module:load_rejected_orders" },
        "Cancelled Orders": { name: "Cancelled Orders", api: "cancelled", functionName: "buy_module:load_cancelled_orders" },
        "Deleted Orders": { name: "Deleted Orders", api: "deleted", functionName: "buy_module:load_deleted_orders" },
        "Payment Pending": { name: "Payment Pending", api: "generated", functionName: "buy_module:load_generated_orders" },
        "Acknowledgement Pending": { name: "Acknowledgement Pending", api: "initiated", functionName: "buy_module:load_manual_orders_without_confirmation" },
        "Share Transfer Pending": { name: "Share Transfer Pending", api: "acknowledged", functionName: "buy_module:load_acknowledged_orders" },
        "Delivery Made": { name: "Delivery Made", api: "deliveryMade", functionName: "buy_module:load_completed_orders" },
        "Dealer Payment Pending": { name: "Dealer Payment Pending", api: "dealerPaymentPending", functionName: "buy_module:load_completed_orders" },
        "Refund Initiated": { name: "Refund Initiated", api: "refund-initiated", functionName: "buy_module:load_all_buy_orders" },
        "Refund Completed Orders": { name: "Refund Completed Orders", api: "refund-completed", functionName: "buy_module:load_refund_initiated_orders" },
        "Intervention Needed": { name: "Intervention Needed", api: "intervention_needed", functionName: "buy_module:load_refund_completed_orders" },
    },
    "sellOrderStatusTypes":
    {
        "All Orders": { name: "All Orders", api: "", functionName: "sell_module:load_all_sell_orders" },
        "Completed Orders": { name: "Completed Orders", api: "completed", functionName: "sell_module:load_completed_orders" },
        "Rejected Orders": { name: "Rejected Orders", api: "rejected", functionName: "sell_module:load_rejected_orders" },
        "Cancelled Orders": { name: "Cancelled Orders", api: "cancelled", functionName: "sell_module:load_cancelled_orders" },
        "Deleted Orders": { name: "Deleted Orders", api: "deleted", functionName: "sell_module:load_deleted_orders" },
        "Customer Generated": { name: "Customer Generated", api: "generated", functionName: "sell_module:load_generated_orders" },
        "Share Transfer Pending": { name: "Share Transfer Pending", api: "shareTransferPending", functionName: "sell_module:load_share_transfer_pending_orders" },
        "Share Transfer Acknowledgement Pending": { name: "Share Transfer Acknowledgement Pending", api: "shareTransfered", functionName: "sell_module:load_share_transfered_orders" },
        "Payment Pending": { name: "Payment Pending", api: "shareTransfereAcknowledged", functionName: "sell_module:load_share_transfer_acknowledged_orders" },
        "Payment Made": { name: "Payment Made", api: "paymentMade", functionName: "sell_module:load_share_transfer_acknowledged_orders" },
        "Dealer Delivery Pending": { name: "Dealer Delivery Pending", api: "dealerDeliveryPending", functionName: "sell_module:mark_order_as_dealer_delivery_pending" },
    },
    "customerStatistics": {
        "Without Account": { name: "Without Account", api: "withoutAccount" },
        "No Order Generated": { name: "No Order Generated", api: "noOrderGenerated" },
        "Atleast One Order Generated": { name: "Atleast One Order Generated", api: "atLeastOneOrderGenerated" },
        "KYC Not Initiated": { name: "KYC Not Initiated", api: "kycNotInitiated" },
        "KYC Pending": { name: "KYC Pending", api: "kycPending" },
        "KYC Rejected": { name: "KYC Rejected", api: "kycRejected" },
        "KYC Approved": { name: "KYC Approved", api: "kycApprovedButNoOrderGenerated" },
        "Atleast One Invoice Generated": { name: "Atleast One Invoice Generated", api: "atLeastOneOrderCompleted" }
    },
    "mandateStatusTypes":
    {
        "Open Mandates": { name: "Open Mandates", status: "OPEN", functionName: "order_mandate:order_mandate" },
        "All Mandates": { name: "All Mandates", status: "All Mandates", functionName: "order_mandate:order_mandate" },
        "Completed Mandates": { name: "Completed Mandates", status: "COMPLETED", functionName: "order_mandate:order_mandate" },
        "Cancelled Mandates": { name: "Cancelled Mandates", status: "CANCELLED", functionName: "order_mandate:order_mandate" },
        "Payment Pending": { name: "Payment Pending", status: "GENERATED", functionName: "order_mandate:order_mandate" },
        "Acknowledgement Pending": { name: "Acknowledgement Pending", status: "INITIATED", functionName: "order_mandate:order_mandate" },
        "Acknowledged Mandates": { name: "Acknowledged Mandates", status: "ACKNOWLEDGED", functionName: "order_mandate:order_mandate" },
        "Refund Initiated": { name: "Refund Initiated", status: "REFUND_INITIATED", functionName: "order_mandate:order_mandate" },
        "Refund Completed": { name: "Refund Completed", status: "REFUND_COMPLETED", functionName: "order_mandate:order_mandate" },
    },
    "mandateStatusLinks": {
        "OPEN": "Open Mandates",
        "": "All Mandates",
        "COMPLETED": "Completed",
        "CANCELLED": "Cancelled",
        "GENERATED": "Pay Pen",
        "INITIATED": "Ackment Pen",
        "ACKNOWLEDGED": "Ack ",
        "REFUND_INITIATED": "Ref Ini",
        "REFUND_COMPLETED": "Ref Comp",
    },
    "crm_order_insights": {
        "all": "All Remarks",
        "OPEN": "Open",
        "PROCESSED": "Processed",
        "REJECTED_BY_ALTIUS": "Rejected by Altius",
        "REJECTED_BY_USER": "Rejected by Investor",
    },
    "crm_insights": {
        "all insights": "All Remarks",
        "latest": "Latest Remark",
        "user": "User specific remark",
        "rm": "RM specific remark",
        "none": "No RM user",
    },
    "untagged_payment_status": {
        "": "All",
        "UNTAGGED": "Untagged",
        "REFUND_INITIATED": "Refund Initiated",
        "REFUNDED": "Refunded",
        "REFUND_FAILED": "Refund Failed",
        "TAGGED": "Tagged",
    },
    "untagged_payment_classification": {
        "": "All",
        "BUY_ORDER": "Buy Order",
        "MANDATE": "Mandate",
        "UNRECOGNIZED_PAYMENT": " Unrecognized Payment"
    },
    "functionList": {
        "kyc:read_user_kyc_info": "kyc:read_user_kyc_info",
        "kyc:update_user_kyc_status": "kyc:update_user_kyc_status",
        "buy_module:update_inventory": "buy_module:update_inventory",
        "buy_module:export_inventory": "buy_module:export_inventory",
        "notification_management:notification_management": "notification_management:notification_management",
        "buy_module:update_buy_order": "buy_module:update_buy_order",
        "buy_module:reject_buy_order": "buy_module:reject_buy_order",
        "buy_module:approve_intervention_needed_buy_order": "buy_module:approve_intervention_needed_buy_order",
        "buy_module:acknowledge_manual_payment_of_buy_order": "buy_module:acknowledge_manual_payment_of_buy_order",
        "buy_module:transfer_shares_of_buy_order": "buy_module:transfer_shares_of_buy_order",
        "buy_module:buy_order_manual_punching": "buy_module:buy_order_manual_punching",
        "buy_module:manual_payment_processing_of_buy_order": "buy_module:manual_payment_processing_of_buy_order",
        "buy_module:load_generated_orders": "buy_module:load_generated_orders",
        "buy_module:load_intervention_needed_orders": "buy_module:load_intervention_needed_orders",
        "buy_module:load_manual_orders_without_confirmation": "buy_module:load_manual_orders_without_confirmation",
        "buy_module:load_acknowledged_orders": "buy_module:load_acknowledged_orders",
        "buy_module:load_rejected_orders": "buy_module:load_rejected_orders",
        "buy_module:load_completed_orders": "buy_module:load_completed_orders",
        "buy_module:load_cancelled_orders": "buy_module:load_cancelled_orders",
        "buy_module:load_all_buy_orders": "buy_module:load_all_buy_orders",
        "buy_module:load_deleted_orders": "buy_module:load_deleted_orders",
        "buy_module:delete_buy_order": "buy_module:delete_buy_order",
        "buy_module:restore_buy_order": "buy_module:restore_buy_order",
        "sell_module:load_all_sell_orders": "sell_module:load_all_sell_orders",
        "sell_module:update_sell_order": "sell_module:update_sell_order",
        "sell_module:reject_sell_order": "sell_module:reject_sell_order",
        "sell_module:approve_order_and_set_status_to_share_transfer_pending": "sell_module:approve_order_and_set_status_to_share_transfer_pending",
        "sell_module:acknowledge_share_transfer": "sell_module:acknowledge_share_transfer",
        "sell_module:mark_order_as_completed": "sell_module:mark_order_as_completed",
        "sell_module:load_generated_orders": "sell_module:load_generated_orders",
        "sell_module:load_share_transfer_pending_orders": "sell_module:load_share_transfer_pending_orders",
        "sell_module:load_share_transfered_orders": "sell_module:load_share_transfered_orders",
        "sell_module:load_share_transfer_acknowledged_orders": "sell_module:load_share_transfer_acknowledged_orders",
        "sell_module:load_completed_orders": "sell_module:load_completed_orders",
        "sell_module:load_cancelled_orders": "sell_module:load_cancelled_orders",
        "sell_module:load_rejected_orders": "sell_module:load_rejected_orders",
        "sell_module:load_deleted_orders": "sell_module:load_deleted_orders",
        "sell_module:delete_sell_order": "sell_module:delete_sell_order",
        "sell_module:restore_sell_order": "sell_module:restore_sell_order",
        "sell_module:sell_order_manual_punching": "sell_module:sell_order_manual_punching",
        "sell_module:transfer_share_on_users_behalf": "sell_module:transfer_share_on_users_behalf",
        "user_management:load_user_details": "user_management:load_user_details",
        "role_management:role_management": "role_management:role_management",
        "remark_management:remark_management": "remark_management:remark_management",
        "social_media:social_media": "social_media:social_media",
        "referral_management:referral_management": "referral_management:referral_management",
        "company_parser:update_company_data": "company_parser:update_company_data",
        "company_parser:export_company_data": "company_parser:export_company_data",
        "company_management:create_company": "company_management:create_company",
        "company_management:update_company": "company_management:update_company",
        "company_management:delete_or_restore_company": "company_management:delete_or_restore_company",
        "company_management:view_company": "company_management:view_company",
        "company_management:update_stocksummary": "company_management:update_stocksummary",
        "company_management:news_management": "company_management:news_management",
        "dashboard_management:manage_dashboard": "dashboard_management:manage_dashboard",
        "kyc:update_distributor_kyc_status": "kyc:update_distributor_kyc_status",
        "kyc:read_distributor_kyc_info": "kyc:read_distributor_kyc_info",
        "distributor_management:load_distributor_details": "distributor_management:load_distributor_details",
        "distributor_management:update_distributor_type": "distributor_management:update_distributor_type",
        "distributor_management:update_distributor_commission": "distributor_management:update_distributor_commission",
        "distributor_management:upload_payout_data_sheet": "distributor_management:upload_payout_data_sheet",
        "distributor_management:manual_entry_in_commission_ledger": "distributor_management:manual_entry_in_commission_ledger",
        "user_management:update_user_utm": "user_management:update_user_utm",
        "bond_management:view_asset_data": "bond_management:view_asset_data",
        "bond_management:create_asset": "bond_management:create_asset",
        "bond_management:update_asset": "bond_management:update_asset",
        "bond_management:delete_or_restore_company": "bond_management:delete_or_restore_company",
        "mld_management:view_asset_data": "mld_management:view_asset_data",
        "mld_management:create_asset": "mld_management:create_asset",
        "mld_management:update_asset": "mld_management:update_asset",
        "mld_management:delete_or_restore_company": "mld_management:delete_or_restore_company",
        "gsec_management:view_asset_data": "gsec_management:view_asset_data",
        "gsec_management:create_asset": "gsec_management:create_asset",
        "gsec_management:update_asset": "gsec_management:update_asset",
        "gsec_management:delete_or_restore_company": "gsec_management:delete_or_restore_company",
        "startup_management:view_asset_data": "startup_management:view_asset_data",
        "startup_management:create_asset": "startup_management:create_asset",
        "startup_management:update_asset": "startup_management:update_asset",
        "startup_management:delete_or_restore_company": "startup_management:delete_or_restore_company",
        "bucket_management:view_asset_data": "bucket_management:view_asset_data",
        "bucket_management:create_asset": "bucket_management:create_asset",
        "bucket_management:update_asset": "bucket_management:update_asset",
        "bucket_management:delete_or_restore_company": "bucket_management:delete_or_restore_company",
        "broadcast:whatsapp": "broadcast:whatsapp",
        "whatsapp:whatsapp": "whatsapp:whatsapp",
        "coupon_management:coupon_management": "coupon_management:coupon_management",
        "crm:add_insight": "crm:add_insight",
        "crm:get_insights": "crm:get_insights",
        "user_pro:user_pro": "user_pro:user_pro",
        "lendbox_data:lendbox_data": "lendbox_data:lendbox_data",
        "liquiloans_data:liquiloans_data": "liquiloans_data:liquiloans_data",
        "user_management:load_user_actions": "user_management:load_user_actions",
        "career_page_management:career_page_management": "career_page_management:career_page_management",
        "order_mandate:order_mandate": "order_mandate:order_mandate",
        "buy_module:complete_refund": "buy_module:complete_refund",
        "buy_module:initiate_refund": "buy_module:initiate_refund",
        "buy_module:load_refund_initiated_orders": "buy_module:load_refund_initiated_orders",
        "buy_module:load_refund_completed_orders": "buy_module:load_refund_completed_orders",
        "depository_parser:depository_parser": "depository_parser:depository_parser",
        "payment_sheet_parser:payment_sheet_parser": "payment_sheet_parser:payment_sheet_parser",
        "sell_module:mark_order_as_dealer_delivery_pending": "sell_module:mark_order_as_dealer_delivery_pending",
        "sell_automation:sell_automation": "sell_automation:sell_automation",
        "prob_parser: prob_parser": "prob_parser: prob_parser",
        "buy_module:mark_order_as_dealer_payment_pending": "buy_module:mark_order_as_dealer_payment_pending",
        "buy_recons:buy_recons": "buy_recons:buy_recons",
        "distributor_management:load_distributor_details": "distributor_management:load_distributor_details",
        "calequity:calequity": "calequity:calequity",
        "company_management:corporate_actions": "company_management:corporate_actions",
        "job_scheduler:job_scheduler": "job_scheduler:job_scheduler",
        "email_broadcast:email_broadcast": "email_broadcast:email_broadcast"
    },
    "functionListUrl": {
        "kyc:read_user_kyc_info": "/kyc",
        "buy_module:update_inventory": "/shareManagement/inventory",
        "buy_module:export_inventory": "/shareManagement/inventory",
        "notification_management:notification_management": "/notificationManagement",
        "buy_module:buy_order_manual_punching": "/shareManagement/manualPunch",
        "buy_module:load_all_buy_orders": "/shareManagement/buyOrders",
        "sell_module:load_all_sell_orders": "/shareManagement/sellOrders",
        "sell_module:sell_order_manual_punching": "/shareManagement/manualPunch",
        "user_management:load_user_details": "/customerStatistics",
        "role_management:role_management": "/roleManagement",
        "remark_management:remark_management": "/remarkManagemnt",
        "social_media:social_media": "/generateSocialMediaImage",
        "referral_management:referral_management": "/referralManagemnt",
        "company_management:view_company": "/companyManagement/companyDetail",
        "company_management:news_management": "/companyManagement/newsDetail",
        "dashboard_management:manage_dashboard": "/customerDashboardManagement",
        "kyc:update_distributor_kyc_status": "/distributor",
        "kyc:read_distributor_kyc_info": "/distributor",
        "distributor_management:load_distributor_details": "/distributorProfile",
        "bond_management:view_asset_data": "/assetManagement/bond",
        "mld_management:view_asset_data": "/assetManagement/mld",
        "gsec_management:view_asset_data": "/assetManagement/gsec",
        "startup_management:view_asset_data": "/assetManagement/startup",
        "bucket_management:view_asset_data": "/assetManagement/bucket",
        "broadcast:whatsapp": "/whatsappBroadcast",
        "coupon_management:coupon_management": "/couponManagemnt",
        "crm:add_insight": "/crm",
        "crm:get_insights": "/crm",
        "user_pro:user_pro": "/proLeads",
        "lendbox_data:lendbox_data": "/lendbox/users",
        "liquiloans_data:liquiloans_data": "/liquiloan/users",
        "career_page_management:career_page_management": "/careerManagemnt",
        "order_mandate:order_mandate": "/mandate",
        "whatsapp:whatsapp": "/whatsappMessages",
        "depository_parser:depository_parser": "/shareManagement/depository",
        "payment_sheet_parser:payment_sheet_parser": "/paymentsheetparser",
        "prob_parser: prob_parser": "/companyManagement/probconverter",
        "sell_automation:sell_automation": "/sellreconcile",
        "buy_recons:buy_recons": "/buyreconcile",
        "calequity:calequity": "/calequity",
        "job_scheduler:job_scheduler": "/jobscheduler",
    },
    "modules": {
        "kyc": "Customer KYC",
        "distKYC": "Distributor KYC",
        "distFormLead": "Distributor Form Lead",
        "custProLead": "Customer Pro Lead",
        "custActions": "Customer Actions",
        "discReport": "Disclaimer Report",
        "custProPayment": "Customer Pro Payment",
        "custXclusivePayment": "Customer Xclusive Payment",
        "custXclusiveLead": "Customer Xclusive Lead",
        "custProReport": "Customer Pro Report",
        "custProPricing": "Customer Pro Plan Pricing",
        "CRM": "User Insights",
        "NoUser": "Non user insights",
        "OrderInsight": "Order Insights",
        "rm": "Role Management",
        "cm": "Company Management",
        "cam": "Corporate Action Management",
        "am": "Admin Management",
        "mn": "Notification Management",
        "mnt": "Notification Template Management",
        "jobScheduler": "Scheduler Management",
        "whatsappBroadcast": "WhatsApp Broadcast",
        "whatsappMessage": "WhatsApp Messages",
        "newsManage": "News Management",
        "smInventory": "Inventory Management",
        "depository": "Depository Parser",
        "manualInventoryUpdate": "Manual Inventory Update",
        "smBuyOrder": "Buy Orders",
        "smCCAvenueHistory": "CCAvenue History",
        "smSellOrder": "Sell Orders",
        "sellReconcile": "Sell Reconcile",
        "buyReconcile": "Buy Reconcile",
        "manualPunch": "Manual Order Punching",
        "mandate": "Mandate Management",
        "custProf": "Customer Profile",
        "distProf": "Distributor Profile",
        "custStat": "Customer Statistics",
        "distStat": "Distributor Statistics",
        "distComm": "Distributor Commission",
        "distCommLed": "Distributor Commission Ledger",
        "distPayout": "Distributor Payout",
        "socialMediaImage": "Social Media",
        "remarkMaster": "Remark Master",
        "referralMaster": "Customer Referral Master",
        "distreferralMaster": "Distributor Referral Master",
        "custDashMng": "Customer Dashboard Management",
        "custDashHighMng": "Customer Dashboard Highlights Management",
        "distDashMng": "Distributor Dashboard Management",
        "promoMgmt": "Promotional Updates Management",
        "mldMgmt": "MLD Management",
        "gsecMgmt": "GSec Management",
        "bondMgmt": "Bond Management",
        "startupMgmt": "Startup Management",
        "bucketMgmt": "Bucket Management",
        "mixBucketMgmt": "Mix Bucket Management",
        "couponMgmt": "Coupon Management",
        "careerMgmt": "Career Management",
        "lbkyc": "Lendbox KYC Request",
        "lbinvest": "Lendbox Investment Orders",
        "lbCase": "Lendbox Case Management",
        "lbwithdraw": "Lendbox Withdrawal Orders",
        "lqkyc": "Liquiloans KYC Request",
        "lqinvest": "Liquiloans Investment Orders",
        "lqwithdraw": "Liquiloans Withdrawal Orders",
        "lqCase": "Liquiloans Case Management",
        "queryForm": "Customer Query Form",
        "paymentSheetParser": "Payment Sheet Parser",
        "probConverter": "Prob Converter",
        "untaggedPaymnet": "Untagged Payment",
        "calequity": "calequity",
        "jobScheduler": "Job Scheduler",
    },
    "statusValues": {
        "rejected": "rejected",
        "verified": "verified",
        "approved": "approved",
        "pending": "pending",
        "initial": "initial"
    },
    "docTypes": {
        "address_proof": "address_proof",
        "bank_proof": "bank_proof",
        "demat_proof": "demat_proof",
        "pan_card": "pan_card",
        "other_document": "other_document"
    },
    "fields": {
        "address": "address",
        "name": "name",
        "pan": "pan"
    },
    "unauthorizedErrorMessage": "Invalid token or unauthorized agent.",
    "createRoleError": {
        "name": "Role Name is required.",
        "desc": "Role Description is required."
    }
}

export const formatCurrency = (amount) => {
    amount = isNaN(amount) ? 0 : amount
    return amount.toLocaleString('en-IN', {
        maximumFractionDigits: 2,
        style: 'currency',
        currency: 'INR'
    })
}

export const formatNumber = (number) => {
    number = isNaN(number) ? 0 : number
    return parseInt(number).toLocaleString('en-IN')
}

// show pdf in new tab
export function showDocNewTab(title, doc) {
    try {
        var win = window.open("#", "_blank");
        win.document.write('<html><title>' + title + '</title><body">');
        if (doc.includes("application/pdf") || doc.includes("application/octet-stream")) {
            let res = convertToBlob(doc)
            win.document.write(`<iframe id="newFrame" src=${URL.createObjectURL(res)} height="100%" width="100%"></iframe>`)
        } else {
            win.document.write(`<embed className="docs-box" src=${doc} type="application/pdf" width="100%" height="100%" /> `);
        }
        win.document.write('</body></html>');
    } catch (error) {

    }
}

// download documents
export function downloadDoc(name, data, excel) {
    try {
        let a = document.createElement("a"); //Create <a>
        a.href = data; //Image Base64 Goes here
        a.download = excel ? `${name}.xlsx` : data.includes("application/pdf") || data.includes("application/octet-stream") ? `${name}.pdf`
            : data.includes("image/png") ? `${name}.png`
                : `${name}.jpg`; //File name Here
        a.click();
    } catch (error) {
        console.error(error)
    }

}

// download image
export async function downloadImage(imageSrc, name) {
    try {
        const image = await fetch(imageSrc)
        const imageBlog = await image.blob()
        const imageURL = URL.createObjectURL(imageBlog)

        const link = document.createElement('a')
        link.href = imageURL
        link.download = name
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    } catch (error) {
        console.error(error)
    }
}

// render large document by converting to blob 
export function convertToBlob(data, frameId, sliceSize = 512, contentType = "application/pdf") {
    try {
        let temp = data.split("base64,")
        const byteCharacters = window.atob(temp[1])
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: contentType });
        if (frameId) {
            let ele = document.getElementById(frameId)
            ele.src = URL.createObjectURL(blob)
        } else {
            return blob
        }
    } catch (error) {
        console.error(error)
    }
}

// hide and show left bar menu
export function showLeftBar(show) {
    try {
        if (show) {
            document.getElementById("leftBar").classList.toggle("d-none")
        } else {
            if (!document.getElementById("leftBar").classList.value.includes("d-none")) {
                document.getElementById("leftBar").classList.toggle("d-none");
            }
        }
    } catch (error) {

    }
}

// const download csv file
export function downloadCSVData(datam, name) {
    try {
        let data = datam.map((datao, index) => flattenObject(datao));
        var keys = Object.keys(data[0])
        const csvRows = [keys.join(",")];

        for (const obj of data) {
            const row = keys.map(key => {
                const val = obj[key] !== undefined && obj[key] !== null ? obj[key] : '';
                return `"${String(val).replace(/"/g, '""')}"`; // escape double quotes
            }).join(",");
            csvRows.push(row);
        }

        const csvString = csvRows.join("\n");
        const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });

        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", `${name}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

    } catch (error) {
        console.error(error)
    }
}

function flattenObject(obj, prefix = '', result = {}) {
    try {
        for (let key in obj) {
            if (!obj.hasOwnProperty(key)) continue;

            const value = obj[key];
            const newKey = prefix ? `${prefix}.${key}` : key;

            if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
                flattenObject(value, newKey, result);
            } else {
                result[newKey] = value;
            }
        }
        return result;
    } catch (error) {
        console.error("Flattening error:", error);
        return {};
    }
}

export function generateBase64(file) {
    return new Promise((resolve, reject) => {

        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);

        fileReader.onload = () => {
            resolve(fileReader.result);
        };

        fileReader.onerror = (error) => {
            reject(error);
        };

    });
}

export function timeConversion(timestamp) {
    try {
        let time = new Date(timestamp * 1000);
        return time.toLocaleString('en-IN', { dateStyle: "short", timeStyle: "short", hour12: true })
    } catch (error) {
        console.error(error);
    }
}

// get cookie
export function getCookie(cname) {
    try {
        let name = `${cname}=`;
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    } catch (error) {
        console.error(error);
    }
}

// set cookie
export function setCookie(data) {
    try {
        if (data) {
            document.cookie = `__mst=${data};path=/`
        }
    } catch (error) {
        console.error(error);
    }
}

// modify portfolio
// filter table data based on input
export function filterData(dataToFilter, filterColumns, filterText, modify) {
    try {
        if (modify) {
            let dataFormatted = [];
            Object.keys(dataToFilter).forEach((element, key) => {
                for (let i = 0; i < dataToFilter[element].length; i++) {
                    let temp = dataToFilter[element][i].holding ? dataToFilter[element][i].holding : dataToFilter[element][i];
                    temp["subCategory"] = element === "listed" ? configs.subCategories[0] : element
                    if (dataToFilter[element][i] && dataToFilter[element][i].holding) {
                        temp["transactions"] = dataToFilter[element][i].transactions ? dataToFilter[element][i].transactions.sort((a, b) => b.date_of_purchase > a.date_of_purchase ? 1 : -1) : [];
                        temp["xirr"] = dataToFilter[element][i].xirr
                    }
                    dataFormatted.push(temp);
                }
            })

            dataToFilter = dataFormatted[0].sell_date ? dataFormatted.sort((a, b) => b.sell_date > a.sell_date ? 1 : -1) : dataFormatted.sort((a, b) => b.latest_txn_date > a.latest_txn_date ? 1 : -1)
        }

        if (!filterText || (filterText && filterText === "All")) {
            return dataToFilter;
        } else {
            var filteredData = [];
            dataToFilter.map((element, key) => {
                let columns = Object.keys(element);
                for (let i = 0; i < columns.length; i++) {
                    if (filterColumns.includes(columns[i]) && element[columns[i]] && filterText && (Array.isArray(filterText) && filterText.some(text => element[columns[i]].toString().toLowerCase().includes(text.toString().toLowerCase())) || element[columns[i]].toString().toLowerCase().includes(filterText.toString().toLowerCase()))) {
                        filteredData.push(element);
                        break;
                    }
                }
            })
            return filteredData
        }
    } catch (error) {
        console.error(error);
    }
}


// format data for holding summary chart
export function formatHoldingChartData(data, columnName) {
    try {
        let sectorValue = {}
        let totalValue = 0;
        let formattedData = [];
        if (data && data.length > 0) {
            data.forEach((element) => {
                if (element.asset_class === "UNLISTED_COMPANY") {
                    sectorValue[element[columnName]] = sectorValue[element[columnName]] ? sectorValue[element[columnName]] + parseFloat(isNaN(element.current_value) ? 0 : element.current_value) : parseFloat(isNaN(element.current_value) ? 0 : element.current_value);

                    totalValue += parseFloat(isNaN(element.current_value) ? 0 : element.current_value);
                }
            })
            Object.keys(sectorValue).forEach((element, key) => {
                if (sectorValue[element] > 0) {
                    formattedData.push({
                        name: element,
                        value: parseFloat(((sectorValue[element] / totalValue) * 100).toFixed(2)),
                    });
                }
            })
        }
        return formattedData;
    } catch (error) {
        console.error(error);
    }
}